import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Kalkulator Protein: Hitung Kebutuhan Protein Harian Tubuh Anda";
const DESCRIPTION =
  "Gunakan kalkulator protein untuk memperkirakan jumlah pasti asupan protein harian (gram/hari) untuk menurunkan berat badan dan membangun kekuatan otot.";
const KEYWORDS =
  "menghitung protein, kalkulator protein, kebutuhan protein harian, asupan protein untuk menurunkan berat badan, membangun otot, meningkatkan kekuatan otot";
const OG_URL = "https://do-calculate.com/calculator/id/protein/";
const data1 = [
  { ageGroup: "1 -> 3", proteinNeeded: 13 },
  { ageGroup: "4 -> 8", proteinNeeded: 19 },
  { ageGroup: "9 -> 13", proteinNeeded: 34 },
  { ageGroup: "14 -> 18 (perempuan)", proteinNeeded: 46 },
  { ageGroup: "14 -> 18 (laki-laki)", proteinNeeded: 52 },
  { ageGroup: "19 -> 70+ (perempuan)", proteinNeeded: 46 },
  { ageGroup: "19 -> 70+ (laki-laki)", proteinNeeded: 56 },
];
const data2 = [
  {
    category: "Trimester pertama kehamilan",
    safeIntake: 1,
    additionalEnergyRequirement: "375 kJ/hari",
    proteinEnergyRatio: 0.04,
  },
  {
    category: "Trimester kedua kehamilan",
    safeIntake: 10,
    additionalEnergyRequirement: "1,200 kJ/hari",
    proteinEnergyRatio: 0.11,
  },
  {
    category: "Trimester akhir kehamilan",
    safeIntake: 31,
    additionalEnergyRequirement: "1,950 kJ/hari",
    proteinEnergyRatio: 0.23,
  },
  {
    category: "6 bulan pertama menyusui",
    safeIntake: 19,
    additionalEnergyRequirement: "2,800 kJ/hari",
    proteinEnergyRatio: 0.11,
  },
  {
    category: "Menyusui setelah 6 bulan pertama",
    safeIntake: 13,
    additionalEnergyRequirement: "1,925 kJ/hari",
    proteinEnergyRatio: 0.11,
  },
];
const data3 = [
  { food: "Susu (1 cup/8 oz)", proteinAmount: "8 g" },
  { food: "Telur (1 large/50 g)", proteinAmount: "6 g" },
  { food: "Daging (1 slice / 2 oz)", proteinAmount: "14 g" },
  { food: "Makanan laut (2 oz)", proteinAmount: "16 g" },
  { food: "Roti (1 slice/64 g)", proteinAmount: "8 g" },
  { food: "Jagung (1 cup/166 g)", proteinAmount: "16 g" },
  { food: "Nasi (1 cup/195 g)", proteinAmount: "5 g" },
  { food: "Kacang kering (1 cup/92 g)", proteinAmount: "16 g" },
  { food: "Kacang-kacangan (1 cup/92 g)", proteinAmount: "20 g" },
  { food: "Buah dan sayuran (1 cup)", proteinAmount: "0-1 g" },
  { food: "Pizza (1 slice/107 g)", proteinAmount: "12 g" },
];
function ProteinCalculator() {
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("male");
  const [height, setHeight] = useState("");
  const [weight, setWeight] = useState("");
  const [activity, setActivity] = useState("sedentary");
  const [resultADA, setResultADA] = useState(null);
  const [resultCDC, setResultCDC] = useState(null);
  const [resultWHO, setResultWHO] = useState(null);
  const [ageError, setAgeError] = useState("");
  const [heightError, setHeightError] = useState("");
  const [weightError, setWeightError] = useState("");
  const handleAgeChange = (event) => {
    const inputAge = event.target.value;
    if (inputAge !== "") {
      const parsedAge = parseInt(inputAge, 10);
      if (!isNaN(parsedAge) && parsedAge >= 18 && parsedAge <= 85) {
        setAge(inputAge);
        setAgeError("");
      } else {
        setAge("");
        if (isNaN(parsedAge)) {
          setAgeError("Pastikan memasukkan angka");
        } else if (parsedAge < 18) {
          setAge(inputAge);
          setAgeError("Usia antara 18 - 85");
        } else if (parsedAge > 85) {
          setAge(inputAge);
          setAgeError("Usia antara 18 - 85");
        }
      }
    } else {
      setAge("");
      setAgeError("");
    }
  };
  const handleHeightChange = (event) => {
    const inputHeight = event.target.value;
    if (inputHeight !== "") {
      if (!isNaN(inputHeight)) {
        setHeight(inputHeight);
        setHeightError("");
      } else {
        setHeight("");
        if (isNaN(inputHeight)) {
          setHeightError("Pastikan memasukkan angka");
        }
      }
    } else {
      setHeight("");
      setHeightError("");
    }
  };
  const handleWeightChange = (event) => {
    const inputWeight = event.target.value;
    if (inputWeight !== "") {
      if (!isNaN(inputWeight)) {
        setWeight(inputWeight);
        setWeightError("");
      } else {
        setWeight("");
        if (isNaN(inputWeight)) {
          setWeightError("Pastikan memasukkan angka");
        }
      }
    } else {
      setWeight("");
      setWeightError("");
    }
  };
  const calculateProtein = () => {
    const proteinIntakeADA = calculateProteinIntakeADA(
      age,
      gender,
      weight,
      activity,
      height
    );
    const proteinIntakeCDC = calculateProteinIntakeCDC(
      age,
      gender,
      weight,
      activity,
      height
    );
    const proteinIntakeWHO = calculateProteinIntakeWHO(
      age,
      gender,
      weight,
      activity,
      height
    );
    return {
      proteinIntakeADA: proteinIntakeADA,
      proteinIntakeCDC: proteinIntakeCDC,
      proteinIntakeWHO: proteinIntakeWHO,
    };
  };
  const calculateProteinIntakeADA = (age, gender, weight, activity) => {
    let proteinIntakeMin = 0;
    let proteinIntakeMax = 0;
    if (age >= 18 && age <= 80) {
      if (gender === "male" || gender === "female") {
        if (activity === "sedentary") {
          proteinIntakeMin = weight * 0.8;
          proteinIntakeMax = weight * 1.0;
        } else {
          proteinIntakeMin = weight * 1.0;
          proteinIntakeMax = weight * 1.8;
        }
      }
    }
    return `${Math.round(proteinIntakeMin)} - ${Math.round(proteinIntakeMax)}`;
  };
  const calculateProteinIntakeCDC = (age, gender, weight, activity, height) => {
    let bmr = 0;
    if (gender === "male") {
      bmr = 10 * weight + 6.25 * height - 5 * age + 5;
    } else if (gender === "female") {
      bmr = 10 * weight + 6.25 * height - 5 * age - 161;
    }
    let activityFactor = 1.0;
    switch (activity) {
      case "sedentary":
        activityFactor = 1.15;
        break;
      case "light":
        activityFactor = 1.325;
        break;
      case "moderate":
        activityFactor = 1.42;
        break;
      case "active":
        activityFactor = 1.52;
        break;
      case "veryActive":
        activityFactor = 1.67;
        break;
      case "extraActive":
        activityFactor = 1.85;
        break;
      default:
        activityFactor = 1.0;
        break;
    }
    const proteinIntakeMin = (0.1 * bmr * activityFactor) / 4;
    const proteinIntakeMax = (0.35 * bmr * activityFactor) / 4;
    return `${Math.round(proteinIntakeMin)} - ${Math.round(proteinIntakeMax)}`;
  };
  const calculateProteinIntakeWHO = (age, gender, weight, activity, height) => {
    let proteinIntake = 0;
    if (age >= 18 && age <= 80) {
      if (gender === "male" || gender === "female") {
        proteinIntake = weight * 0.83;
      }
    }
    return Math.round(proteinIntake);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = calculateProtein();
    setResultADA(result.proteinIntakeADA);
    setResultCDC(result.proteinIntakeCDC);
    setResultWHO(result.proteinIntakeWHO);
  };
  return (
    <div>
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Kalkulator protein memperkirakan jumlah harian protein makanan yang dibutuhkan orang dewasa untuk tetap sehat.
                  <br /> Anak-anak, mereka yang sangat aktif secara fisik, dan wanita hamil serta menyusui biasanya membutuhkan lebih banyak protein.
                  <br />
                  Kalkulator ini juga berguna untuk memantau asupan protein bagi mereka yang menderita penyakit ginjal, penyakit hati, diabetes, atau kondisi lain di mana asupan protein menjadi faktor.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Kalkulator Protein Tubuh
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmit}>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="140"
                      value={height}
                      onChange={handleHeightChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>cm</span>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="65"
                      value={weight}
                      onChange={handleWeightChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>kg</span>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <input
                      placeholder="18"
                      value={age}
                      onChange={handleAgeChange}
                      required
                      className="form-control"
                      style={{ width: "130px", marginLeft: "10px" }}
                    />
                    <span>18 - 85</span>
                  </div>

                  <div className="form-group d-flex align-items-center">
                    <b><label >Jenis Kelamin</label></b>
                    <div style={{ marginRight: "40px" }}>
                      <label style={{ marginLeft: "15px" }}>
                        <input
                          type="radio"
                          value="male"
                          checked={gender === "male"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        {" "}Laki-laki
                      </label>
                      <label>
                        <input
                          type="radio"
                          value="female"
                          checked={gender === "female"}
                          onChange={(e) => setGender(e.target.value)}
                        />
                        {" "}Perempuan
                      </label>
                    </div>
                  </div>

                  <br />

                  <div>
                    <b><label className="form-label ms-2">Tingkat Aktivitas</label></b>
                    <br />
                    <select
                      value={activity}
                      onChange={(e) => setActivity(e.target.value)}
                      className="form-control"
                      style={{ width: "100%", fontSize: "14px" }}
                    >
                      <option value="sedentary">Kurang aktif: sangat sedikit aktivitas fisik atau tidak berolahraga</option>
                      <option value="light">Aktivitas ringan: olahraga ringan 1-3 hari per minggu</option>
                      <option value="moderate">Aktivitas sedang: olahraga sedang 4-5 hari per minggu</option>
                      <option value="active">Aktivitas tinggi: olahraga setiap hari 3-4 kali per minggu</option>
                      <option value="veryActive">Aktivitas intensif: olahraga intensif 6-7 kali per minggu</option>
                      <option value="extraActive">Atlet: latihan sangat intensif setiap hari</option>
                    </select>
                  </div>

                  <br />
                  <hr />

                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}>
                      Hitung
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary"
                      style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}
                      onClick={() => {
                        setAge("");
                        setActivity("sedentary");
                        setGender("male");
                        setHeight("");
                        setWeight("");
                        setResultADA(null);
                        setResultCDC(null);
                        setResultWHO(null);
                        setAgeError("");
                        setHeightError("");
                        setWeightError("");
                      }}
                    >
                      Hapus hasil
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-6 ">
                {resultADA &&
                  resultCDC &&
                  resultWHO &&
                  resultADA !== "0" &&
                  resultCDC !== "0" &&
                  resultWHO !== "0" ? (
                  <div>
                    <p style={{ fontWeight: "bold" }}>
                      Berdasarkan informasi yang diberikan, berikut adalah rekomendasi dasar asupan protein dari beberapa institusi terpercaya:
                    </p>
                    <p>
                      American Dietetic Association (ADA):{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultADA} gram per hari
                      </span>
                    </p>
                    <p>
                      Centers for Disease Control and Prevention (CDC):{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultCDC} gram per hari
                      </span>
                    </p>
                    <p>
                      Batas aman minimum menurut World Health Organization:{" "}
                      <span
                        style={{
                          color: "rgb(25,135,84)",
                          fontWeight: "bold",
                        }}
                      >
                        {resultWHO} gram per hari{" "}
                      </span>
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                Semua yang Perlu Anda Ketahui tentang Protein: Cara Menghitung dan Pentingnya dalam Pola Makan Anda
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>Apa itu protein?</h2>
                </u>
                <br />
                <p>
                  Protein adalah salah satu dari tiga nutrisi penting yang menyediakan energi bagi tubuh manusia, bersama dengan lemak dan karbohidrat. Protein juga bertanggung jawab atas sebagian besar pekerjaan yang dilakukan dalam sel, penting untuk struktur dan fungsi jaringan dan organ yang tepat, serta mengaturnya. Mereka terdiri dari sejumlah asam amino yang penting untuk fungsi tubuh yang tepat, dan berfungsi sebagai bahan pembangun jaringan tubuh. <br /> Ada 20 asam amino yang berbeda secara total, dan urutan asam amino menentukan struktur dan fungsi protein. Sementara beberapa asam amino dapat disintesis dalam tubuh, ada 9 asam amino yang tidak dapat diperoleh manusia kecuali dari sumber makanan (jumlah yang tidak mencukupi terkadang dapat menyebabkan kematian), dan ini disebut asam amino esensial. Makanan yang menyediakan semua asam amino esensial disebut sumber protein lengkap, dan mencakup sumber hewani (daging, produk susu, telur, ikan) serta sumber nabati (kedelai, quinoa, soba).
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Protein dapat diklasifikasikan berdasarkan fungsi yang diberikan kepada tubuh. Berikut adalah daftar beberapa jenis protein:
                  </h2>{" "}
                </u>{" "}
                <br />
                <p>
                  Antibodi: Protein yang melindungi tubuh dari molekul asing, seperti virus dan bakteri, dengan mengikatnya.
                  <br />
                  Enzim: Protein yang membantu membentuk molekul baru serta melakukan banyak reaksi kimia yang terjadi di seluruh tubuh. <br />
                  Messenger: Protein yang mengirimkan sinyal ke seluruh tubuh untuk menjaga proses tubuh <br />
                  Struktural: Protein yang bertindak sebagai bahan pembangun sel yang pada akhirnya memungkinkan tubuh bergerak <br />
                  Transport/Penyimpanan: Protein yang menggerakkan molekul ke seluruh tubuh <br />
                  Seperti yang terlihat, protein memainkan banyak peran penting di seluruh tubuh, oleh karena itu, penting untuk menyediakan nutrisi yang cukup bagi tubuh untuk menjaga kadar protein yang sehat.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Jumlah protein yang dibutuhkan seseorang:
                  </h2>
                </u>
                <br />
                <p>
                  Jumlah protein yang dibutuhkan tubuh manusia setiap hari tergantung pada banyak kondisi, termasuk total asupan energi, pertumbuhan individu, dan tingkat aktivitas fisik. Sering diperkirakan berdasarkan berat badan, sebagai persentase dari total kalori (10-35%), atau berdasarkan usia saja. <br /> 0,8 g/kg berat badan adalah batas diet yang direkomendasikan secara umum. Nilai ini adalah minimum yang direkomendasikan untuk mempertahankan kebutuhan diet dasar, tetapi mengonsumsi lebih banyak protein, bahkan sampai titik tertentu, mungkin bermanfaat, tergantung pada sumber protein. Kisaran asupan protein yang direkomendasikan antara 0,8 g/kg dan 1,8 g/kg berat badan, tergantung pada berbagai faktor yang disebutkan di atas. Orang yang sangat aktif, atau yang ingin membangun lebih banyak otot, umumnya harus mengonsumsi lebih banyak protein. Beberapa sumber menunjukkan konsumsi antara 1,8 hingga 2 g/kg untuk orang yang sangat aktif. Jumlah protein yang harus dikonsumsi seseorang, sejauh ini, bukanlah ilmu pasti, dan setiap individu harus berkonsultasi dengan spesialis, baik itu ahli gizi, dokter, atau pelatih pribadi, untuk membantu menentukan kebutuhan individu mereka.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    Makanan yang tinggi protein:
                  </h2>
                </u>
                <br />
                <p>
                  Ada banyak kelompok makanan berbeda yang dapat dikonsumsi seseorang untuk memenuhi kebutuhan protein mereka. Bagi banyak orang, sebagian besar protein berasal dari konsumsi daging dan produk susu, meskipun mungkin untuk mendapatkan cukup protein sambil memenuhi batasan diet yang mungkin Anda miliki. Secara umum, lebih mudah untuk memenuhi jumlah protein yang direkomendasikan dengan mengonsumsi daging dan produk susu, tetapi kelebihan keduanya dapat berdampak negatif pada kesehatan. Ada banyak pilihan protein nabati, tetapi umumnya mengandung lebih sedikit protein per porsi. Idealnya, seseorang harus mengonsumsi kombinasi daging, produk susu, dan makanan nabati untuk memenuhi kebutuhan nutrisi harian mereka dan mendapatkan diet seimbang yang kaya nutrisi. <br />
                  Contoh daging/susu: Telur, dada ayam, keju, susu, daging sapi, tuna, dada kalkun, ikan, udang. <br />
                  Contoh nabati: Soba, buncis, produk kedelai, selai kacang pada roti panggang atau roti lainnya, kacang-kacangan, nasi, biji rami. <br />
                  Secara umum, daging, unggas, ikan, telur, dan produk susu adalah sumber protein lengkap. Kacang-kacangan, biji-bijian, polong-polongan, sereal, dan sayuran, antara lain, biasanya merupakan protein tidak lengkap. Namun, tidak ada yang salah dengan protein tidak lengkap, dan ada banyak makanan sehat kaya protein yang merupakan protein tidak lengkap. Selama Anda mengonsumsi cukup berbagai protein tidak lengkap untuk mendapatkan semua asam amino yang diperlukan, tidak perlu secara khusus mengonsumsi makanan protein lengkap. Faktanya, beberapa daging merah berlemak tinggi, misalnya, yang merupakan sumber umum protein lengkap, bisa jadi tidak sehat.
                  <br /> Berikut adalah beberapa contoh makanan kaya protein yang bukan merupakan protein lengkap: <br />
                  Almond, oat, brokoli, lentil, roti, biji labu, kacang tanah, kacang hijau, alpukat, jamur.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>Beberapa tabel ilustratif:</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Angka Kecukupan Gizi yang Direkomendasikan untuk Protein, Berdasarkan Usia
                </h3>
              </div>
              <div className="info-section-body">
                <table>
                  <thead>
                    <tr>
                      <th>Protein yang Dibutuhkan (gram/hari)</th>
                      <th>Kelompok Usia (Tahun)</th>
                     </tr>
                  </thead>
                  <tbody>
                    {data1.map((row) => (
                      <tr key={row.ageGroup}>
                        <td>{row.proteinNeeded}</td>
                        <td>{row.ageGroup}</td>
                       </tr>
                    ))}
                  </tbody>
                 </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Kebutuhan Protein Tambahan untuk Kehamilan dan Menyusui:
                </h3>
              </div>
              <div className="info-section-body">
                <table>
                  <thead>
                    <tr>
                      <th>Kategori</th>
                      <th>Asupan Aman (gram/hari)</th>
                      <th>Kebutuhan Energi Tambahan (kJ/hari)</th>
                      <th>Protein: Rasio Energi</th>
                     </tr>
                  </thead>
                  <tbody>
                    {data2.map((row) => (
                      <tr key={row.category}>
                        <td>{row.category}</td>
                        <td>{row.safeIntake}</td>
                        <td>{row.additionalEnergyRequirement}</td>
                        <td>{row.proteinEnergyRatio}</td>
                       </tr>
                    ))}
                  </tbody>
                 </table>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Jumlah Protein dalam Makanan Umum:
                </h3>
              </div>
              <div className="info-section-body">
                <table>
                  <thead>
                    <tr>
                      <th>Makanan</th>
                      <th>Jumlah Protein</th>
                     </tr>
                  </thead>
                  <tbody>
                    {data3.map((row) => (
                      <tr key={row.food}>
                        <td>{row.food}</td>
                        <td>{row.proteinAmount}</td>
                       </tr>
                    ))}
                  </tbody>
                 </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ProteinCalculator;